import {all} from 'redux-saga/effects';
import loginSaga from './sagas/adminLogin';
import importPublishSaga from './sagas/excellImport';

const adminWatcher = function* adminWatcher() {
    yield all([
        loginSaga(),
        importPublishSaga(),
    ]);
};

export default adminWatcher;
